import { PageHeader } from "../../../components/AppLayout";
import { Card } from "../../../components/shared/Card";
import { EmptyState } from "../../../components/shared/EmptyState";

// Placeholder — the full Skills catalog (Firestore /skills + storage)
// will be wired in Phase 4 reusing the SkillForm and listings ported from
// TrueSkills shop.
export function AdminSkillsCatalog() {
  return (
    <>
      <PageHeader title="Skills catalog" subtitle="Public + enterprise skills." />
      <Card>
        <EmptyState
          title="Skills UI in Phase 4"
          description="Backend ready. Wiring SkillForm, moderation queue, and category browser next."
        />
      </Card>
    </>
  );
}
